import React, { useEffect, useState } from "react";
import { MdInfo } from "react-icons/md";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from "@material-ui/core";

import { store } from "../../../store/store";
import logout, * as logout_action from "../../../store/actions/auth";
import * as authActions from "../../../store/actions/auth";
import { constants } from "../../../constants";

const Logout = (props) => {

    const { isAuthenticated } = props;
    const history = useHistory();

    const logoutFunction = async () => {
        store.dispatch({ type: "LOGOUT" });
        localStorage.clear();
    };

    useEffect(() => {
        setTimeout(() => {
            logoutFunction();
        }, 3000);
    }, []);

    return (

        <div className="flex items-center flex-col bg-primary h-screen justify-center">
            {isAuthenticated ?
                <div className="items-center justify-center">
                    <h4 className="text-black font-display font-bold text-4xl">
                        This will take a few seconds, We're logging you out ...
                    </h4>
                </div> :
                <div className="items-center justify-center">
                    <div className="my-3 text-center">
                        <h4 className="text-black font-display font-bold text-4xl">
                            You've been logged out from this application.
                        </h4>
                        <h4 className="text-black font-display font-bold text-4xl">
                            "2gethr greets you the very best for the day.
                        </h4>
                        <h4 className="text-black font-display font-bold text-4xl">
                            See you soon."
                        </h4>
                    </div>
                </div>
            }
            <div className="mt-16 lg:mt-24">
                <Button onClick={() => { history.replace("/") }}>
                    <img
                        src={constants.logo}
                        alt="2gethr Logo"
                        className="h-6 w-18 lg:h-8 lg:w-24"
                    />
                </Button>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, null)(Logout);
